module.exports = __webpack_public_path__ + "static/img/A147.78826d5e.jpg";